/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Document_Gate_Target_RequiredInputs */

const en_api_error_document_gate_target_required = /** @type {(inputs: Api_Error_Document_Gate_Target_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document-gate tasks require a later target case step.`)
};

const pt_br2_api_error_document_gate_target_required = /** @type {(inputs: Api_Error_Document_Gate_Target_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefas de documentos exigem uma etapa posterior como destino.`)
};

/**
* | output |
* | --- |
* | "Document-gate tasks require a later target case step." |
*
* @param {Api_Error_Document_Gate_Target_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_document_gate_target_required = /** @type {((inputs?: Api_Error_Document_Gate_Target_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Document_Gate_Target_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_document_gate_target_required(inputs)
	return pt_br2_api_error_document_gate_target_required(inputs)
});